export const internType = [
  {
    label: "ฝึกงานภาคฤดูร้อน (2 เดือน)",
    value: 1,
  },
  {
    label: "ปฏิบัติสหกิจศึกษา (4 เดือน)",
    value: 2,
  },
  {
    label: "ฝึกงานภาคฤดูร้อนและสหกิจศึกษา (6 เดือน)",
    value: 3,
  },
];
